module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getOrders
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.createOrders
    }
  }, [_vm._v("新增订单")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.orders,
      "highlight-current-row": "",
      "fixed": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "from",
      "width": "70",
      "label": "渠道",
      "formatter": function (row) { return (_vm.fromMap[row.from]); }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderId",
      "label": "订单ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "handleStatus",
      "label": "处理状态",
      "formatter": function (row) { return _vm.getHandleStatus(row); }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "prop": "hotel_id",
      "label": "酒店名",
      "formatter": function (row) { return row.hotel_id ?
        _vm.hotelMap[row.hotel_id][_vm.fromNameMap[row.from]] || _vm.hotelMap[row.hotel_id].tzName :
        '-'; }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "日期",
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('p', [_vm._v("\n          入住日期\n          " + _vm._s(_vm.fecha.format(new Date(s.row.checkInDate), "YYYY-MM-DD")) + "\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          离店日期\n          " + _vm._s(_vm.fecha.format(new Date(s.row.checkOutDate), "YYYY-MM-DD")) + "\n        ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(s.row.stay) + "晚")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(s.row.roomCount) + "间")]), _vm._v(" "), _c('p', [_vm._v("早餐 " + _vm._s(s.row.breakfirst || 0) + " 份")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "价格"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('p', [_vm._v("价格 " + _vm._s(s.row.price))]), _vm._v(" "), _c('p', [_vm._v("原价 " + _vm._s(s.row.floorPrice))]), _vm._v(" "), _c('p', [_vm._v("立减 " + _vm._s(s.row.discount))]), _vm._v(" "), _c('p', [_vm._v("利润 " + _vm._s(s.row.commission))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "guestName",
      "label": "客户名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "goodsName",
      "label": "房型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "结算方式",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('p', [_vm._v(_vm._s(_vm.getPay(s.row)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "note",
      "label": "备注"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("发送")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "价格",
      "prop": "price"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.price),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "price", $$v)
      },
      expression: "editForm.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原价",
      "prop": "floorPrice"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.floorPrice),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "floorPrice", $$v)
      },
      expression: "editForm.floorPrice"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "立减",
      "prop": "discount"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.discount),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "discount", $$v)
      },
      expression: "editForm.discount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "酒店",
      "prop": "hotel_id"
    }
  }, [_c('el-select', {
    staticClass: "long-select",
    attrs: {
      "filterable": ""
    },
    on: {
      "change": function (hId) { return _vm.getPayByHotel(hId, 'editForm'); }
    },
    model: {
      value: (_vm.editForm.hotel_id),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "hotel_id", $$v)
      },
      expression: "editForm.hotel_id"
    }
  }, _vm._l((_vm.hotels), function(hotel, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": +hotel[0],
        "label": hotel[1][_vm.fromNameMap[_vm.editForm.from]] || hotel[1].tzName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "早餐",
      "prop": "breakfirst",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "早餐"
    },
    model: {
      value: (_vm.editForm.breakfirst),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "breakfirst", $$v)
      },
      expression: "editForm.breakfirst"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "note"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.note),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "note", $$v)
      },
      expression: "editForm.note"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "取消订单",
      "prop": "cancel"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.editForm.cancel),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "cancel", $$v)
      },
      expression: "editForm.cancel"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 0,
      "label": "否"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 1,
      "label": "取消"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结算方式",
      "prop": "pay"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.editForm.pay),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "pay", $$v)
      },
      expression: "editForm.pay"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 1,
      "label": "日结"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 2,
      "label": "周结"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 3,
      "label": "月结"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "渠道",
      "prop": "from"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.addForm.from),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "from", $$v)
      },
      expression: "addForm.from"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "同舟",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "代理通",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "同程",
      "value": 3
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "飞猪",
      "value": 4
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "酒店",
      "prop": "hotel_id",
      "required": ""
    }
  }, [_c('el-select', {
    staticClass: "long-select",
    attrs: {
      "filterable": ""
    },
    on: {
      "change": function (hId) { return _vm.getPayByHotel(hId, 'addForm'); }
    },
    model: {
      value: (_vm.addForm.hotel_id),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "hotel_id", $$v)
      },
      expression: "addForm.hotel_id"
    }
  }, _vm._l((_vm.hotels), function(hotel, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": +hotel[0],
        "label": hotel[1][_vm.fromNameMap[_vm.addForm.from]] || hotel[1].tzName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原价",
      "prop": "floorPrice",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "酒店原价"
    },
    model: {
      value: (_vm.addForm.floorPrice),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "floorPrice", $$v)
      },
      expression: "addForm.floorPrice"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "价格",
      "prop": "price",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "价格"
    },
    model: {
      value: (_vm.addForm.price),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "price", $$v)
      },
      expression: "addForm.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "立减",
      "prop": "discount",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "立减"
    },
    model: {
      value: (_vm.addForm.discount),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "discount", $$v)
      },
      expression: "addForm.discount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "房型",
      "prop": "goodsName",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "房型"
    },
    model: {
      value: (_vm.addForm.goodsName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "goodsName", $$v)
      },
      expression: "addForm.goodsName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "客人姓名",
      "prop": "guestName",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "客人姓名"
    },
    model: {
      value: (_vm.addForm.guestName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "guestName", $$v)
      },
      expression: "addForm.guestName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "入住离开日期",
      "required": ""
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "入住日期",
      "end-placeholder": "离店日期"
    },
    model: {
      value: (_vm.addForm.dates),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "dates", $$v)
      },
      expression: "addForm.dates"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "房间数",
      "prop": "roomCount",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "房间数"
    },
    model: {
      value: (_vm.addForm.roomCount),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "roomCount", $$v)
      },
      expression: "addForm.roomCount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "早餐",
      "prop": "breakfirst",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "早餐"
    },
    model: {
      value: (_vm.addForm.breakfirst),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "breakfirst", $$v)
      },
      expression: "addForm.breakfirst"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结算方式",
      "prop": "pay"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.addForm.pay),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "pay", $$v)
      },
      expression: "addForm.pay"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 1,
      "label": "日结"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 2,
      "label": "周结"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 3,
      "label": "月结"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@11.3.4_babel-core@6.26.3_css-loader@0.26.4_vue-template-compiler@2.7.16_webpack@2.7.0/~/vue-loader/lib/template-compiler?{"id":"data-v-218d569d"}!./~/.pnpm/vue-loader@11.3.4_babel-core@6.26.3_css-loader@0.26.4_vue-template-compiler@2.7.16_webpack@2.7.0/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/order/book.vue
// module id = 1124
// module chunks = 1